// extracted by mini-css-extract-plugin
module.exports = {"label":"SavedPaymentMethodsSelect_label__6dhIC"};